<template>
  <blocked-content-wrapper :blocked="blocked" class="home-container mb-5">
    <static-block-component page="event" position="top"/>
    <div v-if="event && event.participants ">
      <div class="d-flex justify-content-center mt-3 align-items-center teams-images-wrapper">
        <template v-if="event.participants.length === 2">
          <div class="team-img" v-if="teams.awayTeam.img">
            <image-component :path="teams.awayTeam.img" :alt="teams.awayTeam.name"/>
          </div>
          <div class="team-img" v-if="teams.homeTeam.img">
            <image-component :path="teams.homeTeam.img" :alt="teams.homeTeam.name"/>
          </div>
        </template>
        <template v-else>
          <div class="img-wrapper"
               :class="{
                  small: event.stream_status !== $options.STREAM_STATUS.upcoming
               }"
               @click.stop.prevent="embeddedPreview && !showEmbeddedPreview && togglePreview(true)"
          >
            <image-component v-if="eventImage" class="event-img" :path="eventImage" alt="banner"/>
            <button-component
                v-if="embeddedPreview && !showEmbeddedPreview"
                variant="icon"
                class="play-preview"
                @btn-click="togglePreview(true)"
            >
              <i class="fas fa-play"/>
            </button-component>
          </div>
        </template>
      </div>
      <div class="font-weight-bold p-2 d-flex align-items-center justify-content-center gap-1">
        <template v-if="event.participants?.length === 2">
          <div class="sport-icon">
            <sport-icons v-if="sport" :sport="sport"/>
          </div>
          <favorite-star-toggle
            :favorite="teams.awayTeam"
            :type="$options.FAVORITES_TYPE.participant"
            class="teams-star"
          />
        </template>
        <span>{{ videoTitle }}</span>
        <template v-if="event.participants?.length === 2">
          <favorite-star-toggle
              :favorite="teams.homeTeam"
              :type="$options.FAVORITES_TYPE.participant"
              class="teams-star"
          />
          <div v-if="gender" class="gender-icon" :class="gender">
            {{ gender }}
          </div>
        </template>
      </div>
      <div class="pb-2">
        <i class="far fa-calendar"></i>
        {{ formattedTime.month }} {{formattedTime.day}}
        &#183;
        {{ formattedTime.hh}} {{formattedTime.zone}}
      </div>
      <div v-if="loading">
        <loader-component/>
      </div>
      <div v-else class="player_wrapper">
        <div class="container" v-if="!event.is_geo_blocked">
          <template v-if="eventUpcoming">
            <div class="flip-section">
              <p>{{ $t('Broadcast starts in') }}:</p>
              <time-flip @timeEnded="onTime"
                         :timestamp="event.event_utc_ts" :countDownPreview="countDownPreview"/>
            </div>
          </template>
          <template v-else>
            <player-controller
                v-if="!embedded"
                :options="videoOptions"
                :event="event"
                :analytics-options="analyticsOptions"
                @interface="onInterfaceGet"
                @play="onPlayChange"
                :sport="sportName"
                :teams="teams"
            />
            <div v-else v-html="embedded"></div>
            <button-component
                @btn-click="toggleChat"
                class="chat-toggle-btn"
                v-if="chatIsEnabled"
            >
              {{ $t(chatDisplayed ? "Hide chat" : "Show chat") }}
            </button-component>
            <div class="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-1">
              <download-button
                  v-if="canDownloadEvent"
                  :api-method="downloadEvent"
                  :id="event.id"
                  class="d-flex"
                  :onRequestFinish="getEventInfo"
              />
              <section class="d-flex gap-1 flex-wrap flex-grow-1 justify-content-end">
                <button-component
                    @btn-click="toggleScore"
                    class="score-toggle-btn"
                    v-if="scoreEnabled"
                >
                  {{ $t(showScore ? "Hide Score" : "Show Score") }}
                </button-component>
                <tutorial-caller
                    v-if="needCutClip && playerInterface"
                    name="clipping_button"
                    positioned="bottom-right"
                >
                  <template v-slot:default="{finishTutorial}">
                    <button-component
                        @btn-click="toggleClipsComponent"
                        @click.native="finishTutorial"
                        title="CLIP.Clip"
                    >
                      {{ $t('CLIP.Clip') }}
                    </button-component>
                  </template>
                </tutorial-caller>
              </section>
            </div>
          </template>
        </div>
        <template v-if="chatIsEnabled">
          <div v-show="chatDisplayed" class="chat">
            <chat-component :event="event"/>
          </div>
        </template>
      </div>
      <clip-cut-component
          v-if="needCutClip && playerInterface && isClipsDisplayed"
          :playerInterface="playerInterface"
          :video-play="videoPlaying"
          :event="event"
          :sportType="sportTagsName"
          :on-clip-creat-requested="getEventInfo"
      />
    </div>

    <adsense-block adClient="ca-pub-9623662250069302" adSlot="8527483633"/>
    <div v-show="scoreEnabled && showScore" class="player_wrapper mt-5">
      <div class="container" v-html="scoreEnabled"></div>
    </div>
    <static-block-component page="event" position="bottom"/>
    <div v-if="showEmbeddedPreview"
         class="embeddeb-preview"
         @click.stop.prevent="togglePreview(false)"
    >
      <div class="content">
        <button-component
            variant="icon"
            class="closeIcon"
            @btn-click="togglePreview(false)"
        >
          <XMarkIcon/>
        </button-component>
        <embedded-player :link="embeddedPreview" :autoplay="true" class="preview-player"/>
      </div>
    </div>
  </blocked-content-wrapper>
</template>

<script>
import WatchScreen from '@/league/views/WatchScreen';
import TutorialCaller from '@/components/onboarding/TutorialCaller.vue';
export default {
  name: 'WatchGameScreen',
  components: {TutorialCaller},
  extends: WatchScreen,
};
</script>

<style lang="scss" scoped src="../../assets/css/watchPage.scss"/>
<style lang="scss" src="../../assets/css/playerPreview.scss"/>
